import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsByAgentIdOptions } from '@onefootprint/fetch-dashboard';
import { IcoSparkles16 } from '@onefootprint/icons';
import type { AiDecisionNodeConfig } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useAgentReleases from '@/hooks/use-agent-releases';
type WhatWillPercyDoProps = {
  config: AiDecisionNodeConfig;
};
const WhatWillPercyDo = t0 => {
  const $ = _c(29);
  const {
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "aiDecisionNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const agentId = config.kind === "agent" ? config.agentId : undefined;
  const agentVersionId = config.kind === "agent" ? config.agentVersionId : undefined;
  const isAgent = config.kind === "agent";
  const t2 = agentId ?? "";
  let t3;
  if ($[1] !== t2) {
    t3 = getOrgAgentsByAgentIdOptions({
      path: {
        agentId: t2
      }
    });
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isAgent || $[4] !== t3) {
    t4 = {
      ...t3,
      enabled: isAgent
    };
    $[3] = isAgent;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const agentQuery = useQuery(t4);
  const releases = useAgentReleases(agentId, isAgent);
  const agentName = agentQuery.data?.name;
  let t5;
  if ($[6] !== agentName || $[7] !== agentVersionId || $[8] !== config.kind || $[9] !== releases.items || $[10] !== t) {
    const versionTag = releases.items.find(r => r.id === agentVersionId)?.versionTag;
    bb0: {
      if (config.kind === "agent") {
        if (agentName && versionTag) {
          t5 = t(_temp, {
            agentName,
            versionTag
          });
          break bb0;
        }
        if (agentName) {
          let t6;
          if ($[12] !== agentName || $[13] !== t) {
            t6 = t(_temp2, {
              agentName
            });
            $[12] = agentName;
            $[13] = t;
            $[14] = t6;
          } else {
            t6 = $[14];
          }
          t5 = t6;
          break bb0;
        }
      }
      if (config.kind !== "agent" && config.kind !== "custom") {
        let t6;
        if ($[15] !== t) {
          t6 = t(_temp3);
          $[15] = t;
          $[16] = t6;
        } else {
          t6 = $[16];
        }
        t5 = t6;
        break bb0;
      }
      let t6;
      if ($[17] !== t) {
        t6 = t(_temp4);
        $[17] = t;
        $[18] = t6;
      } else {
        t6 = $[18];
      }
      t5 = t6;
    }
    $[6] = agentName;
    $[7] = agentVersionId;
    $[8] = config.kind;
    $[9] = releases.items;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const prompt = t5;
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IcoSparkles16 />;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t) {
    t7 = t(_temp5);
    $[20] = t;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t7) {
    t8 = <div className="flex gap-1">{t6}<p className="text-label-2">{t7}</p></div>;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== prompt) {
    t9 = <p className="text-body-2 text-secondary">{prompt}</p>;
    $[24] = prompt;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div className="flex flex-col p-3 gap-2 border border-solid border-tertiary rounded-md">{t8}{t9}</div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default WhatWillPercyDo;
function _temp($) {
  return $.displayPromptByKind.customWithVersion;
}
function _temp2($_0) {
  return $_0.displayPromptByKind.custom;
}
function _temp3($_1) {
  return $_1.displayPromptLegacy;
}
function _temp4($_2) {
  return $_2.displayPromptFallback;
}
function _temp5($_3) {
  return $_3.whatWillPercyDo;
}